/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Budget_MaxInputs */

const cs_public_site_demand_budget_max = /** @type {(inputs: Public_Site_Demand_Budget_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpočet do (Kč)`)
};

const en_public_site_demand_budget_max = /** @type {(inputs: Public_Site_Demand_Budget_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget to (CZK)`)
};

/**
* | output |
* | --- |
* | "Budget to (CZK)" |
*
* @param {Public_Site_Demand_Budget_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_budget_max = /** @type {((inputs?: Public_Site_Demand_Budget_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Budget_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_budget_max(inputs)
	return cs_public_site_demand_budget_max(inputs)
});